import { render, staticRenderFns } from "./ReportPlayerWinloseComponent.vue?vue&type=template&id=5968e1da&"
import script from "./ReportPlayerWinloseComponent.vue?vue&type=script&lang=js&"
export * from "./ReportPlayerWinloseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports